import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { SocialDomainService } from '../../_services/social-domain.service';
import { Client } from '../../_models/social-domain/client.model';
import { WorkProcess } from '../../_models/social-domain/workprocess.model';
import { WorkProcessWithClient } from '../../_models/social-domain/workprocess-with-client.model';
import { InlineSnackbar } from '../inline-snackbar/inline-snackbar';
import { ClientSearch } from '../client-search/client-search';
import { SnackbarType } from '../../_enums/snackbar-type.enum';

@Component({
  selector: 'app-work-process-selector',
  imports: [
    TranslatePipe,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    InlineSnackbar,
    ClientSearch,
  ],
  templateUrl: './work-process-selector.html',
  styleUrl: './work-process-selector.scss',
})
export class WorkProcessSelector implements OnInit {
  @Input() preselected: WorkProcessWithClient | null = null;

  @Output() workProcessSelected = new EventEmitter<WorkProcessWithClient>();

  private readonly socialDomainService = inject(SocialDomainService);

  public workProcesses: WorkProcess[] = [];
  public selectedClient: Client | null = null;
  public selectedWorkProcess: WorkProcess | null = null;
  public areWorkProcessesLoading = false;
  public workProcessesError = false;
  public workProcessesNotFound = false;

  public readonly SnackbarType = SnackbarType;

  public ngOnInit(): void {
    // De voorselectie draagt de cliënt al als volledig object mee, dus er hoeft
    // niets opgezocht te worden om het zoekveld te vullen.
    if (!this.preselected?.client) return;

    this.selectedClient = this.preselected.client;
    this.loadWorkProcesses(this.selectedClient.nummer, (workProcesses) => {
      this.selectedWorkProcess =
        workProcesses.find((w) => w.werkprocesNummer === this.preselected!.werkprocesNummer) ??
        null;
    });
  }

  public onClientSelected(client: Client | null): void {
    this.selectedClient = client;
    this.selectedWorkProcess = null;
    this.workProcesses = [];
    this.workProcessesError = false;
    this.workProcessesNotFound = false;

    if (!client) return;

    this.loadWorkProcesses(client.nummer);
  }

  public onWorkProcessChange(): void {
    if (!this.selectedClient || !this.selectedWorkProcess) return;

    this.workProcessSelected.emit(
      new WorkProcessWithClient({
        ...this.selectedWorkProcess,
        client: this.selectedClient,
      } as WorkProcessWithClient),
    );
  }

  public formatWorkProcessLabel(workProcess: WorkProcess): string {
    return `${workProcess.werkprocesNummer}`;
  }

  private loadWorkProcesses(
    clientNummer: number,
    onLoaded?: (workProcesses: WorkProcess[]) => void,
  ): void {
    this.areWorkProcessesLoading = true;
    this.socialDomainService.getWorkProcessesByClient(clientNummer).subscribe({
      next: (workProcesses) => {
        this.workProcesses = workProcesses ?? [];
        this.areWorkProcessesLoading = false;
        this.workProcessesNotFound = this.workProcesses.length === 0;
        onLoaded?.(this.workProcesses);
      },
      error: () => {
        this.areWorkProcessesLoading = false;
        this.workProcessesError = true;
      },
    });
  }
}
